import RenderIf from "common/components/RenderIf";
import { formatPeriodUnitLabel, formatPrice } from "common/helpers/utils";
import useSubscriptionPricing from "common/hooks/useSubscriptionPricing";
import type {
  PricingPeriodUnit,
  Subscription,
  SubscriptionType,
} from "common/types";

import CurrentCount from "./CurrentCount";
import LicenseBanners from "./LicenseBanners";
import LtdSeats from "./LtdSeats";
import NewPrice from "./NewPrice";
import ToPayNow from "./ToPayNow";

interface PricingInfoProps {
  subscription: Subscription | null;
  currentCount: number;
  newCount: number;
  selectedPeriodUnit: PricingPeriodUnit;
  type: SubscriptionType;
}

export default function PricingInfo({
  subscription,
  currentCount,
  newCount,
  selectedPeriodUnit,
  type,
}: PricingInfoProps) {
  const { license } = useSubscriptionPricing(selectedPeriodUnit, type);

  return (
    <section className="flex flex-col gap-y-2.5">
      <div className="flex items-center justify-between rounded-xl bg-black-100 px-2 py-1">
        <span className="text-button-sm text-black-600">Price per seat</span>

        <span className="text-md-medium text-black-500">
          {formatPrice(license.price / 100)}/
          {formatPeriodUnitLabel(selectedPeriodUnit)}
        </span>
      </div>

      <LtdSeats />

      {/* Current price & Number of items */}
      <RenderIf
        condition={
          subscription &&
          subscription.status !== "cancelled" &&
          subscription.status !== "non_renewing"
        }
      >
        <CurrentCount currentCount={currentCount} subscription={subscription} />
      </RenderIf>

      <div className="flex items-center justify-between px-2 py-1">
        <span className="text-button-sm text-black-600">New no. of seats</span>
        <span className="text-md-bold">{newCount}</span>
      </div>

      <NewPrice
        subscription={subscription}
        type={type}
        newCount={newCount}
        selectedPeriodUnit={selectedPeriodUnit}
      />

      <LicenseBanners
        selectedPeriodUnit={selectedPeriodUnit}
        licenseCount={newCount}
      />

      <ToPayNow
        subscription={subscription}
        type={type}
        newCount={newCount}
        currentCount={currentCount}
        selectedPeriodUnit={selectedPeriodUnit}
      />
    </section>
  );
}
